import {handleApiError} from './common.js'
import itemPayload from '../item-payload.js'
import buildModuleUpdate from './update.js'
import buildModuleComposite from './composite-item.js'
import {SET_LOADING, SET_ERROR, ADD_CHILD, REM_CHILD, DELETED_CHILD, REPLACE_CHILD} from './composite-item.js'

/**
 *
 * @return {{mutations: {}, state: {}, getters: {}, actions: {}, namespaced: boolean, modules}}
 */
export default function buildModuleCompositeUpdate (path, updateProperties, childCreateUrl, childCreateProperties, childUpdateProperties, childProperty, parsed, prepareChild) {
  // FIXME: RESET action is not overridden here - this is a problem as the child slots will remain the same.
  return buildModuleComposite({
    actions: {
      load ({commit, dispatch, getters}, id) {
        // Clear previous children.
        getters.childSlots.map((slotName) => {
          this.unregisterModule(path + '/' + slotName)
            commit(REM_CHILD, slotName)
        })
        return new Promise((resolve, reject) => {
          commit(SET_LOADING, true)
          dispatch('reset').then(() => {
            dispatch('api/fetch', {uri: id}, {root: true})
              .then(response => response.json())
              .then((data) => {
                dispatch('setItem', data)
                  .then((data) => {

                    const promises = data[childProperty].map((childId) => {
                      const slotName = childId.replace(/\//g, '-')
                      const slotPath = path + '/' + slotName
                      if (getters.childSlots.indexOf(slotPath) === -1) {
                        this.registerModule(slotPath, buildModuleUpdate(childUpdateProperties, parsed))
                        commit(ADD_CHILD, slotName)
                      }
                      return new Promise(((resolve, reject) => {
                        dispatch(slotName + '/load', childId)
                          .then(() => {
                            resolve(data)
                          })
                          .catch((e) => {
                            reject(e)
                          })
                      }))
                    })
                    Promise.all(promises).then(() => {
                      commit(SET_LOADING, false)
                      commit(SET_ERROR, '')
                      resolve(data)
                    }, (error) => {
                      commit(SET_LOADING, false)
                      commit(SET_ERROR, error)
                      reject(error)
                    })
                  })
              })
              .catch((e) => {
                commit(SET_LOADING, false)
                commit(SET_ERROR, e.message)
                reject(e)
              })
          })
        })
      },
      save ({ commit, dispatch, getters }) {
        commit(SET_ERROR, '')
        commit(SET_LOADING, true)
        const store = this
        return new Promise((resolve, reject) => {
          dispatch('api/put', {uri: getters.item['@id'], options: {
              body: JSON.stringify(itemPayload(updateProperties, getters.item))
            }}, { root: true })
            .then(response => response.json())
            .then(() => {
              const promisesExisting = []
              const promisesNew = []
              getters.childSlots.map((slotName) => {
                const itemData = getters[`${slotName}/item`]
                // Existing item, push to update list.
                if (itemData['@id']) {
                  promisesExisting.push(dispatch(`${slotName}/save`))
                  return
                }
                // New item, push to create list.
                promisesNew.push(new Promise((resolve, reject) => {
                  dispatch(`${slotName}/save`)
                    .then((createdResult) => {
                      const slotNameNew = createdResult['@id'].replace(/\//g, '-')
                      const slotPathNew = path + '/' + slotNameNew
                      store.unregisterModule(path + '/' + slotName)
                      store.registerModule(slotPathNew, buildModuleUpdate(childUpdateProperties, parsed))
                      commit(REPLACE_CHILD, {oldName: slotName, newName: slotNameNew})
                      dispatch(slotNameNew + '/setItem', createdResult)
                        .then(() => {
                          resolve(createdResult)
                        })
                        .catch((e) => {
                          reject(e)
                        })
                    })
                    .catch((e) => {
                      reject(e)
                    })
                }))
              })

              const promisesDelete = getters.idsToDelete.map((id) => new Promise((resolve, reject) => {
                  dispatch('api/delete', {uri: id}, { root: true })
                    .then(() => {
                      commit(DELETED_CHILD, id)
                      resolve(true)
                    })
                    .catch((e) => {
                      reject(e.message)
                    })
                })
              )

              Promise.all([].concat(promisesDelete, promisesExisting, promisesNew))
                .then(() => {
                  // Load base item again as child updates might have changed it.
                  dispatch('api/fetch', {uri: getters.item['@id']}, { root: true })
                    .then(response => response.json())
                    .then((data) => {
                      commit(SET_LOADING, false)
                      commit(SET_ERROR, '')

                      // FIXME: ensure child slots map the returned data.
                      resolve(data)
                    })
                }, (error) => {
                  commit(SET_LOADING, false)
                  commit(SET_ERROR, error)
                  reject(error)
                })
            }, error => {
              commit(SET_LOADING, false)
              handleApiError({commit, dispatch}, error)
              reject(error)
            })
        })
      },
    },
  }, path, updateProperties, childCreateUrl, childCreateProperties, childUpdateProperties, parsed, prepareChild)
}
